import { render, staticRenderFns } from "./TemplateDataTree.vue?vue&type=template&id=a4678502"
import script from "./TemplateDataTree.vue?vue&type=script&lang=js"
export * from "./TemplateDataTree.vue?vue&type=script&lang=js"
import style0 from "./TemplateDataTree.vue?vue&type=style&index=0&id=a4678502&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports